import { keepPreviousData, useQuery } from "@tanstack/react-query";
import { queryKeys } from "../queryKeys";
import CustomAxios from "../../../utility/customAxios";
import { AttendanceStatus } from "../../../types/Event";
import { Dictionary } from "lodash";

export type UseGetEventsAttendanceProps = {
  uuids: string[];
  employeeUuid: string;
  enabled?: boolean;
};

export type EventsAttendanceResponse = Dictionary<AttendanceStatus | null>;

const fetchEventsAttendance = async (uuids: string[], employeeUuid: string) => {
  const response = await CustomAxios.post<EventsAttendanceResponse>(`events/attendance`, {
    uuids,
    employee_uuid: employeeUuid,
  });
  const { data } = response;
  return data;
};

export function useGetEventsAttendance({
  uuids,
  employeeUuid,
  enabled = true,
}: UseGetEventsAttendanceProps) {
  const query = useQuery({
    enabled: enabled && uuids.length > 0,
    queryKey: [queryKeys.eventAttendance, employeeUuid, uuids],
    queryFn: () => fetchEventsAttendance(uuids, employeeUuid),
    placeholderData: keepPreviousData,
  });
  return query;
}
